/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youreventandimageshavebeenupdatedsuccessfully7Inputs */

const en_youreventandimageshavebeenupdatedsuccessfully7 = /** @type {(inputs: Youreventandimageshavebeenupdatedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your event and images have been updated successfully.`)
};

const de_youreventandimageshavebeenupdatedsuccessfully7 = /** @type {(inputs: Youreventandimageshavebeenupdatedsuccessfully7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Event und deine Bilder wurden aktualisiert.`)
};

/**
* | output |
* | --- |
* | "Your event and images have been updated successfully." |
*
* @param {Youreventandimageshavebeenupdatedsuccessfully7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const youreventandimageshavebeenupdatedsuccessfully7 = /** @type {((inputs?: Youreventandimageshavebeenupdatedsuccessfully7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youreventandimageshavebeenupdatedsuccessfully7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youreventandimageshavebeenupdatedsuccessfully7(inputs)
	return de_youreventandimageshavebeenupdatedsuccessfully7(inputs)
});
export { youreventandimageshavebeenupdatedsuccessfully7 as "yourEventAndImagesHaveBeenUpdatedSuccessfully" }